module.exports = __webpack_public_path__ + "img/footer.84ee728e.png";